<template>
  <div id="app">
    <transition
      mode="out-in"
      :name="animate"
      @before-enter="beforeEnter"
      @after-enter="afterEnter"
    >
      <keep-alive :include="keepAliveRoutes">
        <router-view
          :style="{ height: transing ? pageHeight : 'auto' }"
          v-if="isRouterAlive"
          :class="transing ? 'transing' : ''"
        />
      </keep-alive>
    </transition>
    <!-- 全局加载图标 -->
    <div
      v-if="loading"
      class="loading"
      :style="{height: pageHeight}"
    >
      <via-lottie
        :animation-data="animationData"
        :height="100"
        :width="100"
        :animation-speed="0.8"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as animationData from 'static/lottie/lottie-fruits.json'
import ViaLottie from 'components/common/via-lottie'

export default {
  name: 'App',
  components: {
    [ViaLottie.name]: ViaLottie
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      transing: false,
      animate: 'slide-left',
      loading: false,
      loadingTime: 0,
      lastLoadDate: null,
      animationData: animationData.default,
      isRouterAlive: true
    }
  },
  computed: {
    ...mapState('globalData', {
      direction: state => state.direction
    }),
    // vw
    pageHeight() {
      return this.$pxToVw(this.$clientHeight) + 'vw'
    },
    keepAliveRoutes() {
      const routes = this.$router.options.routes
      const routeNames = this.getRouteNameArr(routes)
      return routeNames
    }
  },
  watch: {
    // 加载图标控制
    '$store.state.globalData.loading'(newValue, oldValue) {
      if (newValue === false && oldValue === true) {
        const loadingTime = this.loadingTime
        const now = new Date()
        if ((now - this.lastLoadDate) > loadingTime) {
          this.loading = newValue
        } else {
          setTimeout(() => {
            this.loading = newValue
          }, loadingTime)
          return
        }
      } else {
        this.loading = newValue
        this.lastLoadDate = new Date()
      }
    },
    '$route'(to, from) {
      if (this.direction === 'forward') {
        this.animate = 'slide-left'
      } else {
        this.animate = 'slide-right'
      }
    }
  },
  methods: {
    // 开始进入页面
    beforeEnter() {
      this.transing = true
    },
    // 结束进入页面
    afterEnter() {
      this.transing = false
    },
    getRouteNameArr(routes) {
      let routeNameArr = []
      for (let i = 0; i < routes.length; i++) {
        const route = routes[i]
        if (route.meta && route.meta.keepAlive) {
          routeNameArr.push(route.name)
        }
        if (route.children) {
          routeNameArr = routeNameArr.concat(this.getRouteNameArr(route.children))
        }
      }
      return routeNameArr
    },
    // 重载页面
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style>
#app {
    margin: 0;
    padding: 0;
    width: 375px;
    font-size: 15px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    background-color: var(--bgColor);
    color: var(--textColor);
}
/* 防止页面抖动 */
.transing {
    width: 375px;
    margin: 0;
    padding: 0;
    position: fixed;
    top: 0;
    left: 0;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
}
.slide-left-enter-active {
    animation: fadeInRight .1s forwards;
}

.slide-left-leave-active {
    animation: fadeOutLeft .2s forwards;
}
 .slide-right-enter-active {
    animation: fadeInLeft .1s forwards;
}

.slide-right-leave-active {
    animation: fadeOutRight .2s forwards;
}

.loading {
  width: 375px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
